<template>
  <div>
    <div class="panel-heading" style="display:flex; justify-content:space-between; align-items:center;">
      <h4 class="panel-title">{{ $t('reports.deliveryReportTitle') }}</h4>
      <img src="../../../assets/images/black_shipzone.png" class="print-only" style="height:40px;" alt="Lasshopping" />
    </div>
    <div class="panel-body" style="display: block">
      <div class="row mb-3 no-print">
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-3">
          <date-picker
            style="margin-top: 4%; border-bottom-color: #919191"
            :date="startTime"
            :option="fromOption"
            class="form-control"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-3">
          <date-picker
            style="margin-top: 4%; border-bottom-color: #919191"
            :date="endTime"
            :option="toOption"
            class="form-control"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4" style="display:flex; align-items:center; flex-wrap:nowrap; gap:8px;">
          <v-btn style="height: auto" @click="getData()" depressed :loading="loading">
            &nbsp; {{ $t('reports.apply') }}
          </v-btn>
          <v-btn v-if="rows.length" class="no-print" @click="printReport()" color="blue-grey" dark small style="height:auto;">
            <v-icon left small>print</v-icon> {{ $t('reports.printReport') }}
          </v-btn>
          <p v-if="rows.length" class="print-only"><strong>{{ $t('reports.periodColon') }} {{ startTime.time }} &mdash; {{ endTime.time }}</strong></p>
        </div>
      </div>

      <table v-if="rows.length" class="table table-bordered">
        <thead style="background-color:#4A8AF4; color:#fff;">
          <tr>
            <th>#</th>
            <th>{{ $t('common.date') }}</th>
            <th>{{ $t('columns.invoiceNo') }}</th>
            <th>{{ $t('columns.customer') }}</th>
            <th>{{ $t('user.staffTitle') }}</th>
            <th>{{ $t('reports.numberOfOrders') }}</th>
            <th>{{ $t('delivery.deliveryPriceIqdTitle') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in rows" :key="index">
            <td>{{ index + 1 }}</td>
            <td>{{ item.created_at | formatDate }}</td>
            <td>{{ item.invoice_number }}</td>
            <td>{{ item.customer_name }}</td>
            <td>{{ item.staff_name }}</td>
            <td>{{ item.order_count }}</td>
            <td>{{ Math.round(item.pay_on_delivery_iqd) }}</td>
          </tr>
        </tbody>
        <tfoot>
          <tr style="background-color:#e9f5b7; font-weight:bold;">
            <td></td>
            <td colspan="4">{{ $t('columns.total') }} <span class="col-sub" style="opacity:1;">{{ $t('reports.sigmaDeliveriesSigmaIqdHint') }}</span></td>
            <td>{{ totals.delivery_count }}</td>
            <td>{{ Math.round(totals.total_delivery_iqd) }}</td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import swal from 'sweetalert'
import myDatepicker from 'vue-datepicker'

export default {
  components: { 'date-picker': myDatepicker },
  filters: {
    formatDate(value) {
      if (!value) return ''
      return value.slice(0, 10)
    }
  },
  data() {
    return {
      loading: false,
      rows: [],
      totals: {},
      startTime: { time: '' },
      endTime: { time: '' },
      fromOption: this.$_datepickerOption(this.$t('columns.fromDate')),
      toOption: this.$_datepickerOption(this.$t('columns.toDate'))
    }
  },
  mounted() {
    this.initCurrentMonth()
  },
  methods: {
    initCurrentMonth() {
      const now = new Date()
      const y = now.getFullYear()
      const m = String(now.getMonth() + 1).padStart(2, '0')
      const lastDay = new Date(y, now.getMonth() + 1, 0).getDate()
      this.startTime.time = `${y}-${m}-01`
      this.endTime.time = `${y}-${m}-${String(lastDay).padStart(2, '0')}`
    },
    getData() {
      if (!this.startTime.time || !this.endTime.time) {
        swal(this.$t('common.error'), this.$t('reports.pleaseSelectFromToDate'), 'error')
        return
      }
      this.loading = true
      const token = localStorage.getItem('access_token')
      axios
        .post('api/report/delivery', { from_date: this.startTime.time, to_date: this.endTime.time }, {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then(res => {
          this.rows = res.data.rows
          this.totals = res.data.totals
        })
        .catch(() => swal(this.$t('common.error'), this.$t('reports.failedToLoadReport'), 'error'))
        .finally(() => { this.loading = false })
    },
    printReport() { window.print() },
    $_datepickerOption(placeholder) {
      return {
        type: 'day',
        week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD',
        placeholder,
        inputStyle: { display: 'inline-block', padding: '6px', 'line-height': '22px', 'font-size': '16px', color: '#2d2d2d', width: '100%' },
        color: { header: '#80864D', headerText: '#ffffff' },
        overlayOpacity: 0.5,
        dismissible: true
      }
    }
  }
}
</script>

<style>
.col-sub {
  display: block;
  font-weight: 400;
  font-size: 10px;
  opacity: 0.85;
  line-height: 1.2;
  margin-top: 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/report/deliveryReport.vue